import SimpleMDE from 'simplemde/dist/simplemde.min.js';
import 'simplemde/dist/simplemde.min.css';

export default SimpleMDE;